import { parseParameters } from "@otto-ec/global-resources/attribute-parser";
import { delegate, undelegate, unsetAll, type Unset } from "@otto-ec/global-resources/event";
import { sheetCreate, sheetOpenById } from "./methods";
import { sheetTagName } from "../utils/consts";
import type { OcSheetV1Props } from "../SheetV1.types.g";
import { findInstance } from "../stack/stack.utils";
import { applyProps } from "../utils/props";

const API_PREFIX = `data-${sheetTagName}` as const;

export const TRIGGER_OPEN = "open";

export const TRIGGER_CREATE = "create";

export const TRIGGER_CLOSE = "close";

export const DATA_SHEET_OPEN = `${API_PREFIX}-${TRIGGER_OPEN}` as const;

export const DATA_SHEET_CREATE = `${API_PREFIX}-${TRIGGER_CREATE}` as const;

export const DATA_SHEET_CLOSE = `${API_PREFIX}-${TRIGGER_CLOSE}` as const;

export type OcSheetV1ConvenienceOptions = {
  container?: string;
  info?: unknown;
};

/**
 *
 *
 */
export const DATA_SHEET_OPEN_LEGACY = "data-oc-sheet-id";

/**
 *
 *
 */
export function handleOpenOnClick(triggerElement: HTMLElement): void {
  const disabled = triggerElement.getAttribute("disabled");
  if (disabled) {
    return;
  }

  /*                            */
  const sheetID = triggerElement.getAttribute(DATA_SHEET_OPEN_LEGACY);
  if (sheetID) {
    sheetOpenById(sheetID);
    return;
  }

  const { info, ...config } = parseParameters<OcSheetV1Props & OcSheetV1ConvenienceOptions>(
    API_PREFIX,
    TRIGGER_OPEN,
    triggerElement,
  );
  if (!config.id) return;

  /*                                             */
  const sheetElement = findInstance(config.id);
  if (sheetElement) applyProps(sheetElement, config);

  /*                    */
  sheetOpenById(config.id, { info });
}

/**
 *
 *
 */
export function handleCreateOnClick(triggerElement: HTMLElement): void {
  const { container, info, ...config } = parseParameters<
    Omit<OcSheetV1Props & OcSheetV1ConvenienceOptions, "open">
  >(API_PREFIX, TRIGGER_CREATE, triggerElement);

  const containerElement = container && document.querySelector<HTMLElement>(container);

  let sheetElement: HTMLOcSheetV1Element;
  if (containerElement) {
    /*                                                                     */
    sheetElement = sheetCreate(config, { container: containerElement });
  } else {
    /*                                                                                   */
    const maybeSheetParent = triggerElement.closest(sheetTagName);

    /*                                                             */
    /*                                                     */
    sheetElement = sheetCreate(config, { adjacentElement: maybeSheetParent ?? triggerElement });
  }

  /*                                                                                           */
  triggerElement.setAttribute(`${DATA_SHEET_CREATE}.id`, sheetElement.id);

  /*                                  */
  sheetOpenById(sheetElement.id, { info });
}

/**
 *
 *
 */
export function handleCloseOnClick(triggerElement: HTMLElement): void {
  const disabled = triggerElement.getAttribute("disabled");
  if (disabled) {
    return;
  }

  const sheetElement = triggerElement.closest(sheetTagName) as HTMLOcSheetV1Element | null;
  if (!sheetElement) {
    if (import.meta.env.DEV)
      console.warn("Clicked close element is not inside a sheet instance", triggerElement);
    return;
  }

  const { info } = parseParameters<OcSheetV1Props & OcSheetV1ConvenienceOptions>(
    API_PREFIX,
    TRIGGER_CLOSE,
    triggerElement,
  );

  sheetElement.close({ info });
}

/**
 *
 *
 */
const SELECTOR_TO_HANDLER = [
  [`[${DATA_SHEET_OPEN}]`, handleOpenOnClick],
  [`[${DATA_SHEET_OPEN_LEGACY}]`, handleOpenOnClick],
  [`[${DATA_SHEET_CREATE}]`, handleCreateOnClick],
  [`[${DATA_SHEET_CLOSE}]`, handleCloseOnClick],
] as const;

/*  */
/*                                                                               */
/*                                                                                                                                */
/*           */
/*  */
/*                                                */
/*                                        */
/*                                                       */
/*                                            */
/*                                                               */
/*     */

/*                               */
/*                                          */
/*    */
/* */

/**
 *
 *
 *
 *
 *
 */
export const initializeListeners = (
  root: Document | HTMLElement | ShadowRoot = document,
  event = "click" as const,
): Unset => {
  return unsetAll(
    ...SELECTOR_TO_HANDLER.map(([selector, handler]) => {
      const listener = (ev: Event): void => {
        const triggerElement = ev.currentTarget;
        if (!(triggerElement instanceof HTMLElement)) return;
        handler(triggerElement);
      };

      delegate(root, event, selector, listener, { passive: true });
      return () => undelegate(root, event, selector, listener);
    }),
  );
};
